export default function WhyAccountant() {
  const cards = [
    {
      title: 'The Entity Gap',
      description: "You're operating without a structure. Your business income, personal assets, and real estate are all in the same bucket. One creditor, one lawsuit, one tenant — and everything is on the table. We build the walls between them.",
      icon: 'ri-building-line'
    },
    {
      title: 'The Tax Bleed',
      description: "You're not cheating on your taxes. You're just overpaying — because nobody built you a plan. The right entity structure doesn't just protect you, it changes what you owe. Legally. We stop the bleed.",
      icon: 'ri-funds-line'
    },
    {
      title: 'The Estate Freeze',
      description: "If your estate plan is a filing cabinet and a prayer, the state will step in. Probate takes 7% and freezes everything for 18 months. Your family waits. The attorneys eat. We lock it down before any of that happens.",
      icon: 'ri-time-line'
    }
  ];

  return (
    <section id="about" className="py-12 md:py-20 bg-[#0a0a0a] relative">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(220, 38, 38, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(220, 38, 38, 0.1) 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-center mb-4 tracking-tight leading-tight">
          WHY YOUR ACCOUNTANT NEVER BROUGHT THIS UP
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-10">
          {cards.map((card, index) => (
            <div
              key={index}
              className="bg-[#1a1a1a] border border-[#2a2a2a] p-6 sm:p-7 rounded-lg hover:border-[#dc2626] transition-all group"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-[#dc2626]/10 rounded-lg mb-4 sm:mb-5 group-hover:bg-[#dc2626]/20 transition-colors">
                <i className={`${card.icon} text-2xl sm:text-3xl text-[#dc2626]`}></i>
              </div>
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold mb-3 text-white">
                {card.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-sm md:text-base">
                {card.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-lg sm:text-xl md:text-2xl font-bold text-[#dc2626] italic px-2">
            The system profits from your inaction. We're built to shut it down.
          </p>
        </div>
      </div>
    </section>
  );
}
